import React from 'react';

interface MiniCardProps {
    title: string;
    icon: React.ReactNode;
    backgroundImage: string;
}

const MiniCard: React.FC<MiniCardProps> = ({ title, icon, backgroundImage }) => {
    return (
        <div className="bg-black h-60 w-96 rounded-[40px] p-6 hover:shadow-2xl transition-shadow duration-300 relative bg-no-repeat bg-cover bg-center" style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className="flex flex-col-reverse md:flex-row justify-between h-full absolute inset-0 p-6">
                <div className="flex flex-col justify-end h-full">
                    <h2 className="text-white text-2xl sm:text-4xl font-bold font-jarkarta">{title}</h2>
                    {/* <a href="#" className="text-white text-lg mt-2 font-inter font-light">Learn More &gt;&gt;</a> */}
                </div>
                <div className="flex flex-col justify-start">
                    <div className="text-white">
                        {React.cloneElement(icon as React.ReactElement, { className: 'w-14 h-full md:w-20' })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MiniCard;
